package org.gymly.ui.admin

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors

/**
 * Datos de un detalle en dos columnas (una sola en pantallas muy estrechas).
 * Cada par es etiqueta y valor; el orden es el de la lista. Se usa en órdenes de membresía y en ventas.
 */
@Composable
internal fun CamposDetalle(campos: List<Pair<String, String>>) {
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val columnas = if (maxWidth >= 360.dp) 2 else 1
        Column(Modifier.fillMaxWidth()) {
            campos.chunked(columnas).forEach { fila ->
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    fila.forEach { (etiqueta, valor) ->
                        Box(Modifier.weight(1f)) { DatoDetalle(etiqueta, valor) }
                    }
                    repeat(columnas - fila.size) { Spacer(Modifier.weight(1f)) }
                }
            }
        }
    }
}

/** Una etiqueta gris con su valor debajo, con el mismo estilo que el resto de los detalles del admin. */
@Composable
internal fun DatoDetalle(etiqueta: String, valor: String) {
    Column(Modifier.padding(bottom = 8.dp)) {
        Text(etiqueta, color = AdminColors.TextMuted, fontSize = 12.sp)
        Text(valor, fontSize = 14.sp, fontWeight = FontWeight.Medium)
    }
}
